import { pdf } from "@react-pdf/renderer";
import QRCode from "qrcode";
import { useEffect, useState } from "react";
import { useLocation , useHistory} from "react-router-dom";
import { errorToast } from "../../../react-toastfiy/toast";
import TaxInvoice from "../common/TaxInvoice";
import invoiceService from "../services/invoice.service";

const PaymentSucess = () => {

    const location = useLocation()
    const history = useHistory()

    const type = location?.state?.type
    const currentUrl = location?.state?.currentUrl
     const [loading, setLoading] = useState(false);
   








    // const searchData = location?.search.split("?")[1]
    // const phone = searchData?.split("=")[1].split("&")[0]
    // const type = searchData?.split("=")[2].split("&")[0]
    // const payment_id = searchData?.split("=")[3].split("&")[0]

    let subtotal = 0

    let gstIncluded = false;

    const [error, setError] = useState(null);
    let subtotalAmount = 0;
    let gstAmount = 0;
    let taxableAmount = 0;
 

    useEffect(() => {

        try {

   
                  setLoading(true)
                        const formData = new FormData();
                        formData.append("phone", location?.state?.phone);
                        if (type === "subscription") {
                             formData.append("order_id", location?.state?.order_id);
                        }else if (type === "bharat_loan") {
                            formData.append("data_id", location?.state?.data_id);
                        }else if (type === "rc") {
                            formData.append("reg_no", location?.state?.reg_no);
                        }else if (type === "backout") {
                             formData.append("uid_ref", location?.state?.uid_ref);
                        }
                         
                        formData.append("type", type);
                        invoiceService.GenerateInvoiceData(formData).then((res) => {
                            if (res.status === 200) {
                                console.log({ res }, res?.data?.line_items);
                                subtotal = res?.data?.line_items?.reduce((sum, item) => sum + Number(item.amount), 0);
                                console.log({ subtotal });
                                const generateAndSendPDF = async () => {
                                    setError(null);
                                    try {
                                        gstIncluded = res?.data?.tax_type;
                                        if (res?.data?.tax_type) {
                                            subtotalAmount = subtotal;
                                            if (res?.data?.state === "Maharashtra") {
                                                // console.log(res?.data?.state === "Maharashtra", { subtotal });

                                                const cgstAmount = (subtotal * res?.data?.cgst) / 100;
                                                const sgstAmount = (subtotal * res?.data?.sgst) / 100;
                                                gstAmount = cgstAmount + sgstAmount;
                                            } else {
                                                // console.log(res?.data?.state !== "Maharashtra", { subtotal });
                                                gstAmount = (subtotal * res?.data?.igst) / 100;
                                            }
                                            if (res?.data?.state === "Maharashtra") {
                                                // For intra-state: taxable amount = subtotal / (1 + (CGST% + SGST%)/100)
                                                const totalTaxRate = (res?.data?.cgst + res?.data?.sgst) / 100;
                                                taxableAmount = subtotalAmount / (1 + totalTaxRate);
                                            } else {
                                                const totalTaxRate = res?.data?.igst / 100;
                                                taxableAmount = subtotalAmount / (1 + totalTaxRate);
                                            }
                                        } else {

                                            if (res?.data?.state === "Maharashtra") {
                                                const cgstAmount = (subtotal * res?.data?.cgst) / 100;
                                                const sgstAmount = (subtotal * res?.data?.sgst) / 100;
                                                gstAmount = cgstAmount + sgstAmount;
                                            } else {

                                                gstAmount = (subtotal * res?.data?.igst) / 100;
                                            }

                                            subtotalAmount = subtotal + gstAmount;
                                            taxableAmount = subtotal;
                                        }
                                        taxableAmount = taxableAmount.toFixed(2);

                                        const qrCodeBase64 = await QRCode.toDataURL(
                                            `https://meratractor-invoices.s3.ap-south-1.amazonaws.com/${res?.data.phone}/${type}/${res?.data.invoiceNumber}.pdf`
                                        );

                                        const customerData = {
                                            name: res?.data.name,
                                            email: res?.data.email,
                                            phone: res?.data.phone,
                                            gst: res?.data.gst,
                                            address: res?.data.address,
                                            city: res?.data.city,
                                            state: res?.data.state,
                                            pincode: res?.data.pincode
                                        };

                                        const billingData = {
                                            invoiceNumber: res?.data.invoiceNumber,
                                            invoiceDate: res?.data.invoice_date,
                                            dueDate: res?.data.due_date,
                                            items: res?.data.line_items,
                                            notes: res?.data.notes
                                        };

                                        const pdfInstance = pdf(
                                            <TaxInvoice
                                                formData={billingData}
                                                data={customerData}
                                                totalAmount={taxableAmount}
                                                gstIncluded={gstIncluded}
                                                subtotalAmount={subtotalAmount}
                                                qrCodeBase64={qrCodeBase64}
                                                type={type}
                                            />
                                        );

                                        const pdfBlob = await pdfInstance.toBlob();

                                        if (!pdfBlob || pdfBlob.size === 0) {
                                            throw new Error("Generated PDF blob is empty");
                                        }

                                        await sendPDFToBackend(pdfBlob, customerData, billingData);

                                        const blobURL = URL.createObjectURL(pdfBlob);

                                        setTimeout(() => {
                                            URL.revokeObjectURL(blobURL);
                                        }, 1000);
                                    } catch (err) {
                                        console.error("Error generating PDF:", err);
                                        setError(`Error generating PDF: ${err.message}`);
                                    } finally {
                                        setLoading(false);
                                    }
                                }

                                generateAndSendPDF();

                            } else {

                                errorToast(res?.msg);
                            }
                        })
            
            
        } catch (error) {

        }

    }, [])

    const sendPDFToBackend = async (pdfBlob, customerData, billingData) => {
        try {

            const formData = new FormData();


            const pdfFile = new File([pdfBlob], `invoice_${billingData.invoiceNumber}.pdf`, {
                type: "application/pdf"
            });

            // console.log({ pdfFile, customerData, billingData });
            formData.append("invoice_pdf", pdfFile);

            


            formData.append("invoice_data", JSON.stringify(customerData, billingData));


            formData.append("phone", customerData?.phone);
            formData.append("gst_number", customerData?.gst ? customerData?.gst : "");
            formData.append("invoice_date", billingData?.invoiceDate);
            formData.append("due_date", billingData?.dueDate);
            formData.append("total_amount", subtotalAmount);
            if (customerData?.state === "Maharashtra") {
                formData.append("cgst", "9");
                formData.append("sgst", "9");
                formData.append("igst", 0);
            } else {
                formData.append("cgst", 0);
                formData.append("sgst", 0);
                formData.append("igst", "18");
            }

            formData.append("taxable_amount", taxableAmount);
            formData.append("tax_type", gstIncluded ? "inclusive" : "exclusive");
            formData.append("line_items", JSON.stringify(billingData?.items));
            formData.append("invoiceNumber", billingData?.invoiceNumber);
             formData.append("notes", "");
            formData.append("type", type);
            if (type === "subscription" ) {
            formData.append("order_id", location?.state?.order_id);                
            formData.append("uid", location?.state?.order_id);
            }  else if (type === "rc") {
                formData.append("reg_no", location?.state?.reg_no);
                formData.append("uid", location?.state?.reg_no);
                
            }else if (type === "backout") {
                   formData.append("uid_ref", location?.state?.uid_ref);
                formData.append("uid", location?.state?.uid_ref);
            }else if (type === "bharat_loan") {
                // formData.append("data_id", location?.state?.data_id);
                formData.append("uid", location?.state?.data_id);
            }
         


            const file = new File([pdfBlob], `${billingData?.invoiceNumber}.pdf`, { type: "application/pdf" });
            formData.append("invoice_pdf", file);

          


            invoiceService.CreateInvoice(formData).then((res) => {
               if (res?.status === 200) {
                 const fileURL = URL.createObjectURL(pdfFile);
                 window.open(res?.data?.invoice_url, "_blank");
                 history.replace(currentUrl)
               
               }
            })


        } catch (error) {
            console.error("Error sending PDF to backend:", error);
            throw error;
        }
    };














    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Generating your invoice...</span>
                    </div>
                    <p className="mt-2">Generating your invoice...</p>
                </div>
            ) : error ? (
                <div className="text-center">
                    <h3>Error</h3>
                    <p className="text-danger">{error}</p>
                    <button
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Retry
                    </button>
                </div>
            ) : (
                <div className="text-center">
                    <h3>Invoice Generated Successfully</h3>
                    <p>Your invoice has been opened in a new tab.</p>
                    {/* <p>If you don't see a new tab, please check your popup blocker settings.</p> */}
                </div>
            )}
        </div>
    )
};

export default PaymentSucess;